<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"padding-bottom:200px;"' class="container " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   </template>
                </m-div><m-h1 v-bind='{...{},...{}}' :style='"border-radius:30px"' class="text-center shadow m-4 p-4" >
                <template #default>اندولیفت   </template>
                </m-h1><m-h4 v-bind='{...{},...{}}' :style='""' class="text-center m-5 h6" >
                <template #default>اندولیفت یک روش لیزر درمانی کم تهاجمی است که برای لیفت و سفت کردن پوست صورت و بدن استفاده می‌شود. این روش شامل استفاده از یک لیزر فیبر نوری برای گرم کردن لایه‌های زیرین پوست است که باعث تولید کلاژن و الاستین جدید می‌شود. در اثر افزایش الاستین و کلاژن بهبود ظاهری چین و چروک‌ها و خطوط ریز، افتادگی پوست و شلی پوست رفع می‌شود. اندولیفت را می‌توان در هر ناحیه‌ای از صورت و بدن از جمله گونه، پیشانی، گردن، غبغب، بازوها، شکم و ران استفاده کرد. این روش معمولا در مطب پزشک انجام می‌شود و حدود 30 تا 60 دقیقه طول می‌کشد.   </template>
                </m-h4><m-img v-bind='{...{"src":"https:\/\/api.arair.ir\/storage\/asset\/21722952147.jpg","alt":"mix it web"},...{}}' :style='"height:900px;\nobject-fit:contain;\n"' class="mx-auto col-12" ></m-img></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH1,mH4,mImg },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
